export default "__VITE_ASSET__DzeOolXf__"